import { render, staticRenderFns } from "./magazineIntroduction.vue?vue&type=template&id=60c45c30&"
import script from "./magazineIntroduction.vue?vue&type=script&lang=js&"
export * from "./magazineIntroduction.vue?vue&type=script&lang=js&"
import style0 from "./magazineIntroduction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports